export default __webpack_public_path__ + "static/media/notify.515cb943.png";